<template>
  <div role="group" :aria-labelledby="`quantity-selector-${id}-label`">
    <label
      :id="`quantity-selector-${id}-label`"
      :for="`quantity-selector-${id}-value`"
      class="sr-only"
    >
      Quantity
    </label>
    <div class="flex">
      <button
        :id="`quantity-selector-${id}-decrement`"
        type="button"
        @click="stepUpDown(-1)"
        :disabled="quantity <= 0"
        :aria-label="`Decrease quantity`"
        class="bg-base-secondary w-12 cursor-pointer rounded text-center font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
      >
        -
      </button>
      <div>
        <input
          :id="`quantity-selector-${id}-value`"
          ref="quantityValue"
          type="number"
          min="0"
          max="99"
          step="1"
          class="bg-transparent w-10 text-center"
          v-model="quantity"
        />
      </div>
      <button
        :id="`quantity-selector-${id}-increment`"
        type="button"
        @click="stepUpDown(1)"
        :disabled="quantity >= 99"
        :aria-label="`Increase quantity`"
        class="bg-base-secondary w-12 cursor-pointer rounded text-center font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
      >
        +
      </button>
    </div>
    <div aria-live="polite" aria-atomic="true" class="sr-only">Quantity: {{ quantity }}</div>
  </div>
</template>
<script lang="ts" setup>
defineProps<{ id: number }>()
const quantity = defineModel<number>({ required: true })
const stepUpDown = (increment: number) => (quantity.value += increment)
</script>
<style scoped>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  opacity: 0;
}
</style>
